
export default {
  install: function (Vue) {
    Vue.mixin({
      methods: {
        sidebarMinimize () {
          document.body.classList.add('sidebar-minimized')
          document.body.classList.add('brand-minimized')
        },
        warnMSG (message, options) {
          this.$toast.warn(Object.assign({}, { title: 'Atenção', message }, options))
          return false
        },
        errorMSG (message, options) {
          this.$toast.error(Object.assign({}, { title: 'Erro', message }, options))
          return false
        },
        succMSG (message, options) {
          this.$toast.success(Object.assign({}, { title: 'Certo!', message }, options))
          return false
        }
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/mixin/index.js